import { Injectable, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { LanguagesService } from './services/language.service';
import { getMacedonianPaginatorIntl } from '../custom-paginator-intl';


@Injectable({
  providedIn: 'root'
})
export class LanguageProvider {

  private translatedItems: any = null;
  langchange: EventEmitter<boolean> = new EventEmitter();

  constructor(private service: LanguagesService) {
  }

  getTranslation(key: string): string {
    const items = this.getTranslatedItems()?.Items;
    const translation = items?.find((x: any) => x.Key === key);
    return translation ? translation.Value : key;
  }

  public getTranslatedItems(): any {
    return this.translatedItems;
  }

  load() {
    this.service.getLocalizedItems()
      .subscribe(response => {
        this.translatedItems = response;
        this.langchange.emit(true);
      });
  }

  changeLanguage(language: any) {
    this.service.changeLanguage({ language }).subscribe(res => {
      this.load();
    });
  }

  translate(property: any) {
    if (!this.getTranslatedItems()) {
      return property;
    }

    const items = this.getTranslatedItems().Items;
    const translation = items.filter((x: { Key: any }) => x.Key === property);

    if (translation && translation.length > 0) {
      return translation[0].Value;
    } else {
      return property;
    }
  }
}
